// extracted by mini-css-extract-plugin
export default {"infoItem":"mA7l_qrg","info":"cUZJCfEM"};